import React from "react";
import { Phone, Mail, Globe, ArrowUp } from "lucide-react";
import { CONTACT, NAV_LINKS, SERVICES } from "../data/content";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-jo-primary text-white overflow-hidden">
      <div className="orb w-[400px] h-[400px] bg-jo-accent/20 -bottom-40 left-1/4" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="h-10 w-10 rounded-xl bg-white/10 backdrop-blur flex items-center justify-center">
                <span className="text-white font-extrabold text-lg">J</span>
              </div>
              <span className="font-bold text-lg">Johar Softech</span>
            </div>
            <p className="text-sm text-white/60 font-light leading-relaxed">
              Empowering Businesses Through Technology &amp; Outsourcing.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-jo-accent mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    onClick={() => scrollTo(l.href)}
                    className="text-sm text-white/60 hover:text-white hover:translate-x-1 transition-[color,transform] duration-300 inline-block"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-jo-accent mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <button
                    onClick={() => scrollTo("#services")}
                    className="text-sm text-white/60 hover:text-white transition-colors text-left"
                  >
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold tracking-wider uppercase text-jo-accent mb-4">
              Contact
            </h4>
            <ul className="space-y-3.5">
              <li>
                <a href={`tel:+${CONTACT.whatsapp}`} className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors">
                  <Phone size={16} className="text-jo-highlight" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors">
                  <Mail size={16} className="text-jo-highlight" /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`https://${CONTACT.website}`} className="flex items-center gap-3 text-sm text-white/70 hover:text-white transition-colors">
                  <Globe size={16} className="text-jo-highlight" /> {CONTACT.website}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Johar Softech. All rights reserved.
          </p>
          <button
            data-testid="back-to-top"
            onClick={() => scrollTo("#home")}
            className="inline-flex items-center gap-2 text-xs font-semibold text-white/70 hover:text-white transition-colors"
          >
            Back to top <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
}
